export const env = {
  VITE_ALOHA_ADMIN: import.meta.env.VITE_ALOHA_ADMIN,
};